import { ZodError, z } from 'zod';
import { RequestSchema } from '@/data/request/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

type CreateBulkRequestsArgs = {
  start_time: string;
  end_time: string;
  type_id: number;
  paid: boolean;
  user_id: number[];
  message: string;
  hours: number;
};

export const createBulkRequests = createWiwAsyncThunk<
  z.infer<typeof CreateBulkRequestsResponse>,
  CreateBulkRequestsArgs
>('request/createBulk', async (request, { rejectWithValue }) => {
  try {
    const response = await Monolith.url('/requests/bulk').post(request);
    return CreateBulkRequestsResponse.parse(response);
  } catch (error) {
    if (error instanceof ZodError) {
      return rejectWithValue(error);
    }

    return rejectWithValue(parseAPIError(error));
  }
});

const CreateBulkRequestsResponse = z.object({
  requests: z.array(RequestSchema).optional(),
  errors: z.any().optional(),
});
